<div class="page">
  <div class="floating-buttons" *ngIf="promotionDetail">
    <div class="floating-buttons__button">
      <svg-icon
        class="floating-buttons__icon"
        src="./assets/icons/share.svg"
      ></svg-icon>
    </div>
  </div>
  <section class="page__header">
    <custom-app-bar [hasBackButton]="true"> </custom-app-bar>
  </section>

  <section class="page__content">
    <img
      class="promotion__image"
      *ngIf="promotionDetail; else imageSkeleton"
      [src]="promotionDetail.image"
      alt="promotion image"
      (click)="openImageViewer()"
    />
    <ng-template #imageSkeleton>
      <ngx-skeleton-loader
              class="skeleton-loader promotion__image"
              [theme]="{
                        'width': '100%',
                        'height': '250px',
                        'border-radius': '0',
                        'background-color': 'var(--skeleton-background-color)',
                        'margin-bottom': '0'
                       }"
      ></ngx-skeleton-loader>
    </ng-template>

    <section class="price_and_code_info" *ngIf="promotionDetail; else priceAndCodeSkeleton">
      <div *ngIf="!(isPriceHidden$ | async)" class="prices__container">
        <div class="promotion-prices__container">
          <p class="promotion__price">
            {{ promotionDetail.price | localizedCurrency }}
          </p>
          <p class="promotion__discounted-price" *ngIf="isLoggedIn$ | async">
            {{
              promotionDetail.discountedPrice != 0
                ? (promotionDetail.discountedPrice | localizedCurrency)
                : ("promotions.free_promotion" | translate)
            }}
          </p>
          </div>
          <app-label class="promotion__label" [text]="'product-label.has-promotion-discount'
                        | translate : { discount: promotionDetail.discount }"
          ></app-label>
      </div>
      <p class="promotion__code">REF. {{ promotionDetail.code }}</p>
    </section>
    <ng-template #priceAndCodeSkeleton>
      <div class="price_and_code_info" style="display: flex; flex-direction: row">
          <ngx-skeleton-loader
                  class="skeleton-loader"
                  count="2"
                  [theme]="{
                        'height': '30px',
                        'width': '85px',
                        'background-color': 'var(--skeleton-background-color)',
                        'margin-bottom': '0',
                        'margin-right': '8px'
                       }"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
                  class="skeleton-loader"
                  style="margin-left: auto;"
                  [theme]="{
                        'height': '29px',
                        'width': '100px',
                        'border-radius': '0',
                        'background-color': 'var(--skeleton-background-color)',
                        'margin-bottom': '0'
                       }"
          ></ngx-skeleton-loader>

      </div>

    </ng-template>

    <article>
      <h1 class="promotion__name" *ngIf="promotionDetail; else headingSkeleton">
        {{ promotionDetail.name }}
      </h1>
      <ng-template #headingSkeleton>
        <ngx-skeleton-loader
                class="skeleton-loader"
                [theme]="{
                        'height': '31px',
                        'max-width': '200px',
                        'background-color': 'var(--skeleton-background-color)'
                       }"
        ></ngx-skeleton-loader>
      </ng-template>
      <p class="promotion__description">{{ promotionDetail?.description }}</p>
    </article>

    <div class="promotion__products">
      <p class="included__products" *ngIf="promotionDetail">
        {{ "promotion_details.included_products" | translate }}
      </p>
      <app-promotion-detail-product-tile
        *ngFor="let product of promotionDetail?.details"
        [product]="product"
      ></app-promotion-detail-product-tile>
    </div>

    <ep-similar-products
      [productsCodes]="productCodes"
      [title]="'promotion_details.related_products' | translate"
    ></ep-similar-products>
  </section>
  <section class="page__footer">
    <app-add-promotion-to-cart-button
      class="add-to-cart__button"
      *ngIf="promotionDetail; else buttonSkeleton"
      [promotionCode]="promotionDetail.code"
      [price]="promotionDetail.discountedPrice"
      size="large"
    ></app-add-promotion-to-cart-button>
    <ng-template #buttonSkeleton>
      <ngx-skeleton-loader
              class="skeleton-loader"
              [theme]="{
                        'height': '56px',
                        'width': '100%',
                        'border-radius': '0',
                        'background-color': 'var(--skeleton-background-color)'
                       }"
      ></ngx-skeleton-loader>
    </ng-template>
  </section>
</div>

<div *ngIf="imageViewerVisibility" class="image-viewer">
  <svg-icon
    class="image-viewer__close-button"
    src="./assets/icons/close.svg"
    (click)="closeImageViewer()"
  ></svg-icon>
  <swiper-container class="image-viewer__swiper swiper"
  zoom-max-ratio="2.5"
  zoom-min-ratio="1">
    <swiper-slide>
      <div class="swiper-zoom-container">
        <img [src]="promotionDetail?.image" alt="promotion image" />
      </div>
    </swiper-slide>
  </swiper-container>
</div>
